import { useState, useEffect } from 'react'
import MD5 from 'crypto-js/md5'

import { postWishlist } from '../newServices/Wishlist';
import getUserProfile from '../newServices/UserProfile'
import { getLogoutSSO, getTokenSSO} from '../newServices/SSO'

import { useStorage64 } from '../hooks/useStorageBase64'
import { useToken } from './useToken'

import { decodeStorage, encodeStorage, removeStorage } from '../functions/storageBase64'


export function useLoginSSO(){
    
    const tokenUD = useToken()
    const { logOut } = useLogout()
    
    const [isTrueWish, setIsTrueWish] = useStorage64('session_token', '');
    const [, setIsCart] = useStorage64('idCarrito', '');
    
    const [urlRedirect, getUrlRedirect] = useState(false)
    const [response, setResponse] = useState(false)
    const [jwt, setJwt] = useState(false)
    const [okLoginResponse, setOkLoginResponse] = useState(false)
    const [loginFinish, setLoginFinish] = useState(false)
    const [loginInit, setLoginInit] = useState(false)
    
    let isLoged; let stateSSO; let nonceSSO; let domain; let redirectURL; let code; let stateURL; let nonceURL; let wishlistAfter; let productAfter; let typeButton
    if (typeof window !== 'undefined') {
        isLoged = decodeStorage('session_token')
        stateSSO = decodeStorage('stateSSO')
        nonceSSO = decodeStorage('nonceSSO' )
        domain = window.location.hostname
        // redirectURL = decodeURIComponent( decodeStorage('redirectURL') )
        
        code = window.location.hash?.split('&code=')[1]?.split('&')?.[0]
        stateURL = window.location.hash?.split('state=')[1]?.split('&')?.[0]
        nonceURL = window.location.hash?.split('nonce=')[1]?.split('&')?.[0]
    
        wishlistAfter = decodeStorage('wishlistAfter')
        productAfter = decodeStorage('productAfter')
        typeButton = decodeStorage('typeButton')
    }


    // Valida el stateURL sea el mismo que regresa keycloak 
    useEffect(()=>{
        if(loginInit){
            if(code){
                if(!isLoged){
                    if(stateSSO === stateURL){

                        getTokenSSO({'code': code})
                        .then(setResponse)
                    }else{
                        window.location.replace( `${window.location.origin}/login` )
                    }
                }else{
                    window.location.replace( window.location.origin )
                }
            }else{
                window.location.replace( window.location.origin )
            }
            setLoginInit(false)
        }
    },[loginInit])

    useEffect(()=>{
        const domain = window.location.hostname
        
        if(response){
                document.cookie = `access_token=;Max-Age=${0};Path=/;Domain=${domain};`
                document.cookie = `refresh_token=;Max-Age=${0};Path=/;Domain=${domain};`
                document.cookie = `token_login=;Max-Age=${0};Path=/;Domain=${domain};`;
                document.cookie = `token_cart=;Max-Age=${0};Path=/;Domain=${domain};`;
        
            if(response.statusCode === 200){
                // console.log(response)
                // console.log(response.data.access_token)
                // console.log(response.data.refresh_token)

                encodeStorage('access_token',response.data.access_token)
                encodeStorage('refresh_token',response.data.refresh_token)
                document.cookie = `access_token=${response.data.access_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                document.cookie = `refresh_token=${response.data.refresh_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                
                
                const tokenJWT = window.atob(response.data.access_token?.split('.')[1])
                const tokenRefreshJWT = window.atob(response.data.refresh_token?.split('.')[1])
                
                document.cookie = `token_login=${response.data.access_token};Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`
                document.cookie = `token_cart=${ MD5(`${JSON.parse(tokenJWT)?.email}`).toString()  };Max-Age=${60 * 60 * 24 * 365};Path=/;Domain=${domain};`

                // console.log('tokenJWT: ',tokenJWT)
                // console.log('tokenRefreshJWT: ',tokenRefreshJWT)
                
                encodeStorage('access_token_exp', JSON.parse(tokenJWT)?.exp)
                encodeStorage('refresh_token_exp', JSON.parse(tokenRefreshJWT)?.exp)

                encodeStorage('session_token', response.data.access_token)
                encodeStorage('idCarrito', MD5(`${JSON.parse(tokenJWT)?.email}`).toString() )

                setTimeout(()=> {
                    setJwt(response.data.access_token)
                },700)
                
            }else if(response.statusCode === 400){
                isLoged = decodeStorage('session_token')
                console.log('redirectURL: ',redirectURL)
                const redirURL = decodeURIComponent( decodeStorage('redirectURL') )?.replace(window.location.origin,'')
                if(isLoged){
                    if(redirURL){
                        window.location.href = redirURL
                    }
                    else{
                        window.location.href = window.location.origin
                    }
                }else{
                    window.location.href = `${window.location.origin}/login`
                }
                
            }
        }
    },[response])

    useEffect(()=>{
        if(jwt){
            // console.log('access_token: ',decodeStorage('access_token'))
            // tokenUD.forceToken(true)
            setOkLoginResponse(true)
        }
    },[jwt])

    // - Evalua si viene desde un producto o wishlist
    const [responseFav, setResponseFav] = useState(false)
    useEffect(() => {
        if (okLoginResponse) {
            if (wishlistAfter) {
                setIsTrueWish( decodeStorage('session_token') )
                postWishlist({ idProduct: wishlistAfter })
                .then(setResponseFav)
            }
            else if (productAfter) {
                setIsCart( decodeStorage('idCarrito') )
                setLoginFinish(true)
                if (typeButton === 'buttonBuyNow') {
                    encodeStorage('okBuyProductAfter', true)
                } else if (typeButton === 'buttonAddToCart') {
                    encodeStorage('okCartProductAfter', true)
                }
            } else {
                // console.log('nada de wish ni prodxuto')
                setLoginFinish(true)
            }
        }
    }, [okLoginResponse])

    // - agrega al wishlist despues del login cuando vienen desde alli 
    useEffect(() => {
        if (responseFav) {
            setLoginFinish(true)
            encodeStorage('productsWishlist', [String(wishlistAfter)])
            removeStorage('wishlistAfter')
        }
    }, [responseFav])

    const [profileGet, setProfleGet] = useState(false);
    const [profileResponse, setProfleResponse] = useState();
    const [ref, setRef] = useState(false)
    useEffect(() => {
        if(loginFinish){
            setRef(true)
        }
    }, [loginFinish]);


    useEffect(()=>{
        if(ref){
            const time = decodeStorage('access_token')
            const timeToken = JSON.parse( window.atob( time?.split('.')[1] ) )
            setRef(false)
            if(  Date.now() >= (timeToken?.iat * 1000) ){
                getUserProfile()
                .then(setProfleResponse)
                setLoginFinish(false)
            }else{
                const tiempo = Math.floor( (timeToken?.iat * 1000) - Date.now() ) + 1000
                console.log('preTime: ', tiempo)
                setTimeout(()=> {
                    getUserProfile()
                    .then(setProfleResponse)
                    setLoginFinish(false)
                },tiempo)
            }
        }    
    },[ref])

    useEffect(() => {
        if (profileResponse) {
            if(profileResponse?.statusCode === 200) {
                if(profileResponse?.data) {
                    if(profileResponse?.data?.data) {
                        // console.log('profileResponse use login: ',profileResponse)
                        const {
                            name,
                            email,
                            id,
                            last_name,
                            second_last_name,
                            gender,
                            birthday
                        } = profileResponse?.data?.data
                        
                        const userDataProfile = {
                            idClaro: id,
                            nombre: name,
                            apellidoP: last_name,
                            apellidoM: second_last_name,
                            nombreCompleto: `${name} ${last_name} ${second_last_name}`,
                            genero: gender,
                            cumpleanios: birthday,
                            correo: email
                        }                      
                        setProfleGet(userDataProfile);
                        encodeStorage('LoginDate', Date.now() )
                        const portal = decodeStorage('CONFIGVAR')?.portal
                        try{
                            window.ineum('meta', `Id_${portal}`, id);
                            window.ineum('user', id, name, email);
                            window.ineum('meta', 'LoginDate', Date.now() );
                            window.ineum('meta', 'Logout', 'null');
                        }catch(e){}
                    }
                }
            }
            else if(profileResponse.statusCode === 401){
                setLoginFinish(true)
                logOut()
                
            }
            else{
                // console.log('error: ', profileResponse.statusCode )
            }
        }
    }, [profileResponse]);



    useEffect(()=>{
        if(profileGet){
            isLoged = decodeStorage('session_token')
            encodeStorage('profileData', profileGet)
            const redirURL = decodeURIComponent( decodeStorage('redirectURL') ).replace(window.location.origin,'')
            if(isLoged){
                if(redirURL){
                    window.location.replace( redirURL )
                }else{
                    window.location.replace( window.location.origin )
                }
                // setLoading(false)
            }
        }
    },[profileGet])


    // recibe los datos del formulario
    const reciveRedirect = (val) => {
        getUrlRedirect(val)
    }

    const initLogin = (val) => {
        setLoginInit(val)
    }
    
    const dataLogin = {
        jwt
    }

    return {
        dataLogin,
        reciveRedirect,
        initLogin
    }
}


export function useLogout(){    
    
    const [logoutClick, setLogoutClick] = useState(false)
    const [finish, setFinish] = useState(false)
    const [respLogO, setRespLogO] = useState(false)
    const [alter, setAlter] = useState(false)
    
    useEffect(()=>{
        if(logoutClick){
            getLogoutSSO()
            .then(setRespLogO)
            setTimeout(()=> {
                setAlter(true)
            },700)
        }
    },[logoutClick])
    
    useEffect(()=>{
        // console.log('****************')
        // console.log('logoutClick:  ',logoutClick)
        // console.log(':::  ',respLogO)
        // console.log(':::  ',respLogO.statusCode)
        // console.log('alter:  ',alter)
        // console.log('finish:  ',finish)
        if(respLogO){
            if(respLogO?.statusCode === 204){
                setFinish(true)
                setAlter(false)
                setLogoutClick(false)
            }
            else if(respLogO?.statusCode === 400){
                setFinish(true)
                setAlter(false)
                setLogoutClick(false)
            }else{
                setFinish(false)
                setAlter(false)
                setLogoutClick(false)
            }
        }else if(alter){
            setFinish(true)
            setAlter(false)
            setLogoutClick(false)
        }
    },[respLogO, alter])


    useEffect(()=>{
        if(finish){
            // console.log('useLogin - logOut')
            removeStorage('session_token')
            removeStorage('idCarrito')
            removeStorage('sendDirections')
            removeStorage('total_items')
            removeStorage('profileData')
            removeStorage('productsWishlist')
            removeStorage('cartData')
            removeStorage('selectId')
            removeStorage('shipping')
            removeStorage('dirPredeterminada')
            removeStorage('codigoPostal')
            removeStorage('existDirPredeterminada')
            removeStorage('telefono_usuario')
            removeStorage('saldoTelmexService')
            removeStorage('cartFormEm')
            removeStorage('busquedas')
            removeStorage('dataFacebook')
            removeStorage('typeButton')
            removeStorage('wishlistAfter')
            removeStorage('productAfter')
            removeStorage('okCartProductAfter')
            removeStorage('okBuyProductAfter')
            removeStorage('access_token')
            removeStorage('refresh_token')
            removeStorage('refresh_token_exp')
            removeStorage('access_token_exp')
    
            /* -- Credito variables --*/
            removeStorage('sears_numero_internet')
            removeStorage('cardending')
            removeStorage('nombreTitular')
            removeStorage('email')
            removeStorage('associatedCards')
            removeStorage('lastConsultData')
            removeStorage('payCardRelation')
            removeStorage('addCardPreLogin')


            removeStorage('montoCredito');
            removeStorage('creditoDisponible');
            removeStorage('fechaManana');
            removeStorage('flagAceptoCredito');
            removeStorage('respGetListCs');
            removeStorage('respuestaGetCard')
            removeStorage('creditoCS_cupon');
            
            /* -- Mesa variables --*/
            removeStorage('GIFT_TABLE_DATA');
            removeStorage('CURRENT_GIFT_TABLE');
            
            window.sessionStorage.removeItem('respCart')
            window.sessionStorage.removeItem('updateCategory')
            window.sessionStorage.removeItem('productTotal')
            
            window.localStorage.removeItem('closebtnMT-detalle')
            window.localStorage.removeItem('closebtnMT-home')

            const domain = window.location.hostname
    
            document.cookie = `SSID=;Max-Age=${0};Path=/;Domain=${domain};`
            document.cookie = `SCID=;Max-Age=${0};Path=/;Domain=${domain};`
            document.cookie = `jwt=;Max-Age=${0};Path=/;Domain=${domain};`
            document.cookie = `access_token=;Max-Age=${0};Path=/;Domain=${domain};`
            document.cookie = `refresh_token=;Max-Age=${0};Path=/;Domain=${domain};`
            
            document.cookie = `token_login=;Max-Age=${0};Path=/;Domain=${domain};`;
            document.cookie = `token_cart=;Max-Age=${0};Path=/;Domain=${domain};`;
            document.cookie = `token_api_manager=;Max-Age=${0};Path=/;Domain=${domain};`;


            
            // postLogoutOldPortal();
            // removeStorage('LoginDate')
            encodeStorage('LogoutDate', Date.now() )
            setTimeout(() => {
                if (window.location.pathname === '/')
                    window.location.reload();
                else if (!window.location.pathname.includes('login')) {
                    window.location.replace('/');
                }
                else {
                    window.location.reload();
                }
            }, 700)
            setFinish(false)
        }
    },[finish])


    const logOut = () => {
        setLogoutClick(true)
    }
    return {
        logOut
    }
}